var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRateHalf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97564 0L13.2228 5.53629L19.5284 6.89225L15.2297 11.6698L15.8796 18.0442L9.97564 15.4606L4.07169 18.0442L4.72161 11.6698L0.422852 6.89225L6.72847 5.53629L9.97564 0Z",
    fill: "#BABCBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07071 18.0442L9.97466 15.4606V0L6.72749 5.53629L0.421875 6.89225L4.72063 11.6698L4.07071 18.0442Z",
    fill: "#E0B36A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateHalf);
export default __webpack_public_path__ + "static/media/rate-half.b42fd9257f8d4b1a0385640d3b1abfae.svg";
export { ForwardRef as ReactComponent };